/* ==========================================================================
   PressDollz storefront helpers
   - Quick Add on product cards (direct add, or option picker modal)
   - "Complete your set" cart upsell buttons
   - Subtle added-to-bag confirmation

   Cart writes go through Shopify's own /cart/add endpoint and re-render the
   theme's existing cart sections. Product data for the option picker comes
   from Shopify's native /products/<handle>.js endpoint, so it always matches
   the real, current options, variants, availability and prices.
   ========================================================================== */
(function () {
  'use strict';

  var CFG = window.pdShop || {};
  var ROUTES = window.routes || {};
  var ADD_URL = ROUTES.cart_add_url || '/cart/add';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------------------------------------------------------------- utils */

  function parseDoc(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function withWidth(url, width) {
    if (!url) return '';
    var src = typeof url === 'string' ? url : url.src || '';
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function formatMoney(cents, format) {
    var fmt = format || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = fmt.match(placeholder);
    if (match == null) return fmt;

    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      var fixed = (number / 100.0).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }

    var value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = withDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = withDelimiters(cents, 0, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = withDelimiters(cents, 2, ' ', '.');
        break;
      default:
        value = withDelimiters(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }

  /* ------------------------------------------------------ cart re-rendering */

  function sectionIdOf(elementId) {
    var node = document.getElementById(elementId);
    return node && node.dataset ? node.dataset.id : null;
  }

  function sectionsToRequest() {
    var list = [];
    if (document.querySelector('cart-drawer')) list.push('cart-drawer');
    if (document.getElementById('cart-icon-bubble')) list.push('cart-icon-bubble');
    var items = sectionIdOf('main-cart-items');
    if (items) list.push(items);
    var footer = sectionIdOf('main-cart-footer');
    if (footer) list.push(footer);
    return list;
  }

  function replaceInner(containerId, selector, html) {
    var container = document.getElementById(containerId);
    if (!container || !html) return;
    var target = selector ? container.querySelector(selector) || container : container;
    var source = parseDoc(html).querySelector(selector || '.shopify-section');
    if (!source) return;
    target.innerHTML = source.innerHTML;
  }

  // Refresh the cart drawer in place. Mirrors CartDrawer.renderContents but
  // deliberately does NOT open the drawer, so browsing is never interrupted.
  function refreshDrawer(html, itemCount) {
    var drawer = document.querySelector('cart-drawer');
    var target = document.getElementById('CartDrawer');
    if (!drawer || !target || !html) return;
    var source = parseDoc(html).querySelector('#CartDrawer');
    if (!source) return;

    target.innerHTML = source.innerHTML;
    if (itemCount !== null) drawer.classList.toggle('is-empty', itemCount === 0);

    var overlay = drawer.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.addEventListener('click', function () {
        if (typeof drawer.close === 'function') drawer.close();
      });
    }
  }

  function applyCartResponse(data) {
    if (!data || !data.sections) return;
    var count = typeof data.item_count === 'number' ? data.item_count : null;

    refreshDrawer(data.sections['cart-drawer'], count);
    replaceInner('cart-icon-bubble', '.shopify-section', data.sections['cart-icon-bubble']);

    var itemsSection = sectionIdOf('main-cart-items');
    if (itemsSection) replaceInner('main-cart-items', '.js-contents', data.sections[itemsSection]);

    var footerSection = sectionIdOf('main-cart-footer');
    if (footerSection) {
      replaceInner('main-cart-footer', '.js-contents', data.sections[footerSection]);
      var footerEl = document.getElementById('main-cart-footer');
      if (footerEl && count !== null) footerEl.classList.toggle('is-empty', count === 0);
    }

    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pd-quick-add', cartData: data });
      }
    } catch (e) {
      /* pub/sub is a nicety, never a requirement */
    }
  }

  function addToCart(variantId, quantity) {
    var body = {
      items: [{ id: Number(variantId), quantity: quantity || 1 }],
      sections: sectionsToRequest(),
      sections_url: window.location.pathname
    };

    return fetch(ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        return response.json().then(function (json) {
          return { ok: response.ok, data: json };
        });
      })
      .then(function (result) {
        if (!result.ok || result.data.status) {
          throw new Error(result.data.description || result.data.message || 'Could not add to bag');
        }
        applyCartResponse(result.data);
        return result.data;
      });
  }

  /* ---------------------------------------------------------------- toast */

  var toastTimer = null;

  function toast(message) {
    var node = document.getElementById('pd-toast');
    if (!node) return;
    var text = node.querySelector('.pd-toast__text');
    if (text) text.textContent = message;
    node.classList.add('is-visible');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      node.classList.remove('is-visible');
    }, 4000);
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest('.pd-toast__open')) return;
    event.preventDefault();
    var node = document.getElementById('pd-toast');
    if (node) node.classList.remove('is-visible');
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    } else {
      window.location.href = ROUTES.cart_url || '/cart';
    }
  });

  /* ------------------------------------------------- cart upsell (+ ADD) */

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('button.pd-up__add');
    if (!btn) return;
    event.preventDefault();

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || btn.classList.contains('is-busy')) return;

    var label = btn.textContent;
    btn.classList.add('is-busy');
    btn.textContent = 'Adding';

    addToCart(variantId, 1).catch(function (error) {
      btn.classList.remove('is-busy');
      btn.textContent = label;
      toast(error.message || 'Could not add to bag');
    });
  });

  /* -------------------------------------------------------- quick add btn */

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.pd-qa__btn');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();

    if (btn.classList.contains('is-busy')) return;

    var title = btn.getAttribute('data-product-title') || 'Item';

    if (btn.getAttribute('data-needs-options') === 'true') {
      openModal(btn.getAttribute('data-product-url'), btn);
      return;
    }

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    btn.classList.add('is-busy');
    addToCart(variantId, 1)
      .then(function () {
        btn.classList.remove('is-busy');
        btn.classList.add('is-done');
        setTimeout(function () {
          btn.classList.remove('is-done');
        }, 1400);
        toast('Added to bag - ' + title);
      })
      .catch(function (error) {
        btn.classList.remove('is-busy');
        toast(error.message || 'Could not add to bag');
      });
  });

  /* ------------------------------------------------------ quick add modal */

  var modal = null;
  var panel = null;
  var lastFocused = null;
  var state = null;

  function ensureModal() {
    if (modal) return modal;
    modal = document.getElementById('pd-quick-add-modal');
    if (modal) panel = modal.querySelector('.pd-qam__body');
    return modal;
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-ready');
    document.body.style.removeProperty('overflow');
    setTimeout(function () {
      modal.classList.remove('is-open');
      if (panel) panel.innerHTML = '';
      state = null;
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }, 220);
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('.pd-qam__close') || event.target.closest('.pd-qam__overlay')) {
      event.preventDefault();
      closeModal();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && modal && modal.classList.contains('is-open')) closeModal();
  });

  function handleFromUrl(url) {
    var match = String(url || '').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function openModal(productUrl, opener) {
    var handle = handleFromUrl(productUrl);
    if (!handle || !ensureModal()) {
      if (productUrl) window.location.href = productUrl;
      return;
    }

    lastFocused = opener || null;
    if (opener) opener.classList.add('is-busy');

    fetch(ROOT + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('unavailable');
        return response.json();
      })
      .then(function (data) {
        if (!data || !data.variants || !data.variants.length) throw new Error('unavailable');
        buildModal(data, productUrl);
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        requestAnimationFrame(function () {
          modal.classList.add('is-ready');
        });
        var closeBtn = modal.querySelector('.pd-qam__close');
        if (closeBtn) closeBtn.focus();
      })
      .catch(function () {
        // Never strand the customer: fall back to the real product page.
        window.location.href = productUrl;
      })
      .then(function () {
        if (opener) opener.classList.remove('is-busy');
      });
  }

  function optionNames(data) {
    return (data.options || []).map(function (option) {
      return typeof option === 'string' ? option : option.name;
    });
  }

  function buildModal(data, productUrl) {
    var names = optionNames(data);
    var variants = data.variants.map(function (variant) {
      return {
        id: variant.id,
        options: variant.options || [variant.option1, variant.option2, variant.option3].slice(0, names.length),
        available: variant.available !== false,
        price: variant.price,
        compare: variant.compare_at_price,
        image: variant.featured_image ? withWidth(variant.featured_image, 400) : null
      };
    });

    state = {
      names: names,
      variants: variants,
      selected: names.map(function () {
        return null;
      })
    };

    state.values = names.map(function (_, index) {
      var seen = [];
      variants.forEach(function (variant) {
        var value = variant.options[index];
        if (value != null && seen.indexOf(value) === -1) seen.push(value);
      });
      return seen;
    });

    panel.innerHTML = '';

    /* head ---------------------------------------------------------------- */
    var head = el('div', 'pd-qa-head');
    var media = el('div', 'pd-qa-head__media');
    if (data.featured_image) {
      var img = document.createElement('img');
      img.setAttribute('data-pd-image', '');
      img.src = withWidth(data.featured_image, 400);
      img.alt = '';
      img.loading = 'lazy';
      media.appendChild(img);
    }
    var info = el('div');
    info.appendChild(el('h2', 'pd-qa-head__title', data.title));
    var price = el('p', 'pd-qa-head__price', formatMoney(data.price, CFG.moneyFormat));
    price.setAttribute('data-pd-price', '');
    info.appendChild(price);
    head.appendChild(media);
    head.appendChild(info);
    panel.appendChild(head);

    /* options -------------------------------------------------------------- */
    var optionsHost = el('div');
    optionsHost.setAttribute('data-pd-options', '');
    panel.appendChild(optionsHost);

    names.forEach(function (name, index) {
      var group = el('div', 'pd-qa-opt');
      group.setAttribute('data-option-index', String(index));

      var groupHead = el('div', 'pd-qa-opt__head');
      groupHead.appendChild(el('span', 'pd-qa-opt__name', name));
      groupHead.appendChild(el('span', 'pd-qa-opt__chosen', ''));

      var list = el('div', 'pd-qa-opt__values');
      state.values[index].forEach(function (value) {
        var button = el('button', 'pd-qa-val', value);
        button.type = 'button';
        button.setAttribute('aria-pressed', 'false');
        button.setAttribute('data-value', value);
        button.addEventListener('click', function () {
          if (button.hasAttribute('disabled')) return;
          state.selected[index] = state.selected[index] === value ? null : value;
          syncOptions();
        });
        list.appendChild(button);
      });

      group.appendChild(groupHead);
      group.appendChild(list);
      optionsHost.appendChild(group);
    });

    /* size guide ----------------------------------------------------------- */
    var hasSize = names.some(function (name) {
      return /size/i.test(name);
    });
    if (hasSize) {
      var sizeBtn = el('button', 'pd-qa-size', 'Not sure about your size?');
      sizeBtn.type = 'button';
      panel.appendChild(sizeBtn);
    }

    /* add to bag ----------------------------------------------------------- */
    var addBtn = el('button', 'pd-qa-add', 'Select options');
    addBtn.type = 'button';
    addBtn.setAttribute('disabled', 'disabled');
    addBtn.setAttribute('data-product-title', data.title);
    addBtn.setAttribute('data-label-select', 'Select options');
    addBtn.setAttribute('data-label-soldout', 'Sold out');
    addBtn.setAttribute('data-label-add', 'Add to bag');
    panel.appendChild(addBtn);

    var err = el('p', 'pd-qa-err', '');
    err.setAttribute('role', 'alert');
    panel.appendChild(err);

    var full = el('a', 'pd-qa-full', 'View full details');
    full.href = productUrl;
    panel.appendChild(full);

    /* size guide sheet ------------------------------------------------------ */
    var guide = el('div', 'pd-qa-guide');
    var back = el('button', 'pd-qa-guide__back', '← Back');
    back.type = 'button';
    var guideBody = el('div');
    guideBody.setAttribute('data-pd-guide-body', '');
    guide.appendChild(back);
    guide.appendChild(guideBody);
    panel.appendChild(guide);

    // A single-value option has nothing to decide, so pick it automatically.
    names.forEach(function (_, index) {
      if (state.values[index].length === 1) state.selected[index] = state.values[index][0];
    });

    syncOptions();
  }

  function matchVariant(selection) {
    return state.variants.filter(function (variant) {
      return selection.every(function (value, index) {
        return value === null || variant.options[index] === value;
      });
    });
  }

  function syncOptions() {
    if (!state) return;

    state.names.forEach(function (_, index) {
      var group = panel.querySelector('[data-option-index="' + index + '"]');
      if (!group) return;

      var chosen = group.querySelector('.pd-qa-opt__chosen');
      if (chosen) chosen.textContent = state.selected[index] || '';

      Array.prototype.forEach.call(group.querySelectorAll('.pd-qa-val'), function (button) {
        var value = button.getAttribute('data-value');
        var probe = state.selected.slice();
        probe[index] = value;
        var reachable = matchVariant(probe).some(function (variant) {
          return variant.available;
        });
        if (reachable) {
          button.removeAttribute('disabled');
        } else {
          button.setAttribute('disabled', 'disabled');
        }
        button.setAttribute('aria-pressed', state.selected[index] === value ? 'true' : 'false');
      });
    });

    var complete = state.selected.every(function (value) {
      return value !== null;
    });
    var candidates = matchVariant(state.selected);
    var available = candidates.filter(function (variant) {
      return variant.available;
    });
    var variant = complete ? available[0] || candidates[0] || null : null;

    var addBtn = panel.querySelector('.pd-qa-add');
    var priceEl = panel.querySelector('[data-pd-price]');
    var imageEl = panel.querySelector('[data-pd-image]');

    if (variant && priceEl) priceEl.textContent = formatMoney(variant.price, CFG.moneyFormat);
    if (variant && variant.image && imageEl) imageEl.setAttribute('src', variant.image);

    if (!addBtn) return;

    if (!complete) {
      addBtn.setAttribute('disabled', 'disabled');
      addBtn.textContent = addBtn.getAttribute('data-label-select');
      addBtn.removeAttribute('data-variant-id');
    } else if (!variant || !variant.available) {
      addBtn.setAttribute('disabled', 'disabled');
      addBtn.textContent = addBtn.getAttribute('data-label-soldout');
      addBtn.removeAttribute('data-variant-id');
    } else {
      addBtn.removeAttribute('disabled');
      addBtn.textContent = addBtn.getAttribute('data-label-add');
      addBtn.setAttribute('data-variant-id', String(variant.id));
    }
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.pd-qa-add');
    if (!btn || btn.hasAttribute('disabled')) return;
    event.preventDefault();

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var title = btn.getAttribute('data-product-title') || 'Item';
    var label = btn.textContent;
    btn.classList.add('is-busy');
    btn.textContent = 'Adding';

    addToCart(variantId, 1)
      .then(function () {
        closeModal();
        toast('Added to bag - ' + title);
      })
      .catch(function (error) {
        btn.classList.remove('is-busy');
        btn.textContent = label;
        var err = panel.querySelector('.pd-qa-err');
        if (err) err.textContent = error.message || 'Could not add to bag';
      });
  });

  /* --- size guide, loaded from the existing Size guide page -------------- */

  document.addEventListener('click', function (event) {
    if (!event.target.closest('.pd-qa-size')) return;
    event.preventDefault();

    var guide = panel && panel.querySelector('.pd-qa-guide');
    if (!guide) return;

    guide.classList.add('is-open');

    var body = guide.querySelector('[data-pd-guide-body]');
    if (!body || body.getAttribute('data-loaded') === 'true') return;

    var guideUrl = CFG.sizeGuideUrl || '/pages/chart-size';

    fetch(guideUrl + '?section_id=main-page')
      .then(function (response) {
        if (!response.ok) throw new Error('unavailable');
        return response.text();
      })
      .then(function (html) {
        var doc = parseDoc(html);
        var source = doc.querySelector('.shopify-section') || doc.body;
        body.innerHTML = source.innerHTML;
        body.setAttribute('data-loaded', 'true');
      })
      .catch(function () {
        var link = el('a', null, 'Open the size guide');
        link.href = guideUrl;
        link.target = '_blank';
        link.rel = 'noopener';
        body.innerHTML = '';
        body.appendChild(link);
      });
  });

  document.addEventListener('click', function (event) {
    var back = event.target.closest('.pd-qa-guide__back');
    if (!back) return;
    event.preventDefault();
    var guide = back.closest('.pd-qa-guide');
    if (guide) guide.classList.remove('is-open');
  });
})();